(function () {
  var loaded = false;
  var events = ['scroll', 'click', 'touchstart', 'mousemove', 'keydown'];

  function loadSmartsupp() {
    if (loaded) return;
    loaded = true;
    console.log('[Smartsupp] Chargement déclenché par interaction utilisateur');

    events.forEach(function (e) {
      document.removeEventListener(e, loadSmartsupp, { passive: true });
    });

    window._smartsupp = window._smartsupp || {};
    window._smartsupp.key = '2fc5a4430dd867f75817e0986552d2fcf2af18a3';

    var s = document.getElementsByTagName('script')[0];
    var c = document.createElement('script');
    c.type = 'text/javascript';
    c.charset = 'utf-8';
    c.async = true;
    c.src = 'https://www.smartsuppchat.com/loader.js?';
    c.onload = function () {
      console.log('[Smartsupp] loader.js chargé avec succès');
    };
    c.onerror = function () {
      console.error('[Smartsupp] Erreur au chargement de loader.js');
    };
    s.parentNode.insertBefore(c, s);
  }

  events.forEach(function (e) {
    document.addEventListener(e, loadSmartsupp, { passive: true });
  });

  console.log('[Smartsupp] Lazy load en attente d\'interaction...');
})();
